module.exports = __webpack_public_path__ + "static/img/1.094446a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/1.jpg
// module id = AtQ3
// module chunks = 1